export const INDUSTRY_LIST = "INDUSTRY_LIST";
export const INDUSTRY_DETAILS = "INDUSTRY_DETAILS";
export const INDUSTRY_NAME_LIST = "INDUSTRY_NAME_LIST";